import {
    fetchCarrierAction,
} from 'wanderu-ducks-carriers';
import {
    fetchTripAction,
    tripSelectors,
} from 'wanderu-ducks-trips';

import {
    ROUTED_TRIP_DELIMITER,
} from '../../../constants';

function fetchCarrierData(tripId) {
    return async function(dispatch, getState) {
        const ids = tripId.split(ROUTED_TRIP_DELIMITER);
        const trips = ids.map((id) => tripSelectors.selectTrip(getState(), id));

        const hasError = ids
            .map((id) => fetchTripAction.selectError(getState(), id))
            .some((error) => !!error);

        if (hasError) {
            return;
        }

        await Promise.all(
            trips.map(({ carrierCode }) => dispatch(fetchCarrierAction.fetchCarrier(carrierCode))),
        );
    };
}

export {
    fetchCarrierData,
};
